<template>
  <div>
    <div class="row">
      <!-- Title -->
      <div class="stage-title">Płatności</div>
      <hr/>
    </div>
    <div class="row top-space">
      <ul class="nav nav-tabs">
        <li class="nav-item common-tab">
          <a :class="unpaidTabClass" aria-current="page" @click="openPaymentsStage('UNPAID')">Nieopłacone</a>
        </li>
        <li class="nav-item common-tab">
          <a :class="paidTabClass" @click="openPaymentsStage('PAID')">Opłacone</a>
        </li>
        <li class="nav-item common-tab">
          <a :class="problematicTabClass" @click="openPaymentsStage('PROBLEMATIC')">Błędne</a>
        </li>

      </ul>

      <div v-if="currentPaymentType === 'UNPAID'">
        <UnpaidPaymentsStage/>
      </div>
      <div v-else-if="currentPaymentType === 'PAID'">
        <PaidPaymentsStage/>
      </div>
      <div v-else-if="currentPaymentType === 'PROBLEMATIC'">
        <ProblematicPaymentsStage/>
      </div>


    </div>


  </div>

</template>


<script>

import PaidPaymentsStage from "./PaidPaymentsStage.vue";
import UnpaidPaymentsStage from "./UnpaidPaymentsStage.vue";
import ProblematicPaymentsStage from "./ProblematicPaymentsStage.vue";
import {log} from "@/state/pinia/log";
import {usePaymentsManagerModule} from "@/state/pinia/paymentsManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";



export default {
  name: "PaymentsStage",
  props: {},
  components: {

    ProblematicPaymentsStage,
    UnpaidPaymentsStage,
    PaidPaymentsStage

  },
  data() {
    return {
      unpaidTabClass: "nav-link active",
      paidTabClass: "nav-link",
      problematicTabClass: "nav-link",
      currentPaymentType: "UNPAID",

      // Example Table data
tableData:[],


    };
  },
  computed: {
    paymentsModule(){
      return usePaymentsManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {


    openPaymentsStage(openedPaymentType) {
      this.currentPaymentType = openedPaymentType;
      if (openedPaymentType === "UNPAID") {
        this.unpaidTabClass = "nav-link active";
        this.paidTabClass = "nav-link";
        this.problematicTabClass = "nav-link";
      } else if (openedPaymentType === "PAID") {
        this.unpaidTabClass = "nav-link";
        this.paidTabClass = "nav-link active";
        this.problematicTabClass = "nav-link";
      } else if (openedPaymentType === "PROBLEMATIC") {
        this.unpaidTabClass = "nav-link";
        this.paidTabClass = "nav-link";
        this.problematicTabClass = "nav-link active";

      }

    }

  },
  watch: {},
  mounted() {

  },
  created() {
    log.log("trigger refresh token")
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    });
  },
};
</script>

<style scoped>

.top-space {
  margin-top: 20px;
}

.common-tab {
  cursor: pointer;
}

</style>
